<template>
  <app-page
    title="Bulk import"
    subtitle="Upload a file"
    :icon="getEntityIcon(query?.entity)"
    :previous="[{ label: entity || 'Dashboard', to: { name: entity?.toLowerCase() || 'sme-dashboard' } }]"
  >
    <app-loading v-if="loading" />
    <sme-alert v-else-if="error" level="danger">
      Your account has not been configured to upload {{ query?.entity || 'on the portal' }}. Please contact your account
      manager.
    </sme-alert>
    <template v-else>
      <app-input
        v-model="entity"
        :validate-immediate="false"
        name="Entity"
        label="What would you like to upload?"
        rules="required"
        :type="CONTROL_TYPES.SELECT"
        :options="Object.keys(displayMap)"
      />
      <sftp-bulk-upload v-if="entity" :entity="displayMap[entity]" :title="entity.toLowerCase()" />
    </template>
  </app-page>
</template>

<script setup>
import { onBeforeMount, ref } from 'vue';
import { useRoute } from 'vue-router/composables';
import ApiClient from '@/ApiClient';
import AppInput, { CONTROL_TYPES } from '@/components/AppInput.vue';
import AppLoading from '@/components/AppLoading.vue';
import AppPage from '@/components/AppPage.vue';
import SmeAlert from '@/components/atoms/SmeAlert.vue';
import SftpBulkUpload from '@/pages/SftpBulkUpload/components/SftpBulkUpload.vue';
import IntegrationsState from '@/state/IntegrationsState';
import State from '@/state/State';
import { toTitleCase } from '@/utils/common';

const $route = useRoute();

const query = $route.query;

const loading = ref(false);
const error = ref(false);
const entity = ref(null);
const displayMap = ref({});

const format = value => toTitleCase(value).replace('_', ' ');

const getEntityIcon = entityType => {
  const entityIcons = {
    jobs: 'briefcase',
    employees: 'users',
    expanded_employees: 'users',
    shifts: 'calendar-circle-plus',
    absences: 'user-clock',
  };
  return entityIcons[entityType] || 'user-plus';
};

onBeforeMount(async () => {
  loading.value = true;

  try {
    await ApiClient.getIntegrations(State.state.company.company_id);
    const rawEntities = IntegrationsState.getBrowserUploadEntities();

    if (!rawEntities || rawEntities.length === 0) {
      error.value = true;
      loading.value = false;
      return;
    }

    displayMap.value = rawEntities.reduce((acc, curr) => {
      if (curr.includes(query.entity)) {
        acc[format(curr)] = curr;
      }
      return acc;
    }, {});

    if (Object.keys(displayMap.value).length === 0) {
      error.value = true;
    } else if (query.entity && Object.values(displayMap.value).includes(query.entity)) {
      entity.value = format(query.entity);
    }
  } catch (err) {
    console.error('Failed to load integrations:', err);
    error.value = true;
  }

  loading.value = false;
});
</script>
